import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { canvasBackend } from './canvas.backend';
import { canvasReducer } from './canvas.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('canvas', canvasReducer),
    BackendModule.forFeature('canvas', canvasBackend),
  ],
})
export class DatastoreCanvasModule {}
